//UA取得
var ua = navigator.userAgent;
var isSP =
  ua.indexOf("iPhone") > 0 ||
  ua.indexOf("iPod") > 0 ||
  (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0);
var isTab =
  ua.indexOf("iPad") > 0 ||
  (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") === -1) ||
  ua.indexOf("A1_07") > 0 ||
  ua.indexOf("SC-01C") > 0;

jQuery(function ($) {
  //SP否定
  if (!isSP) {
    $(".sp-link").on("click", function () {
      return false;
    });
  }
  //SP時
  if (isSP) {
  }
  //tablet時
  if (isTab) {
  }
  $(window).on("load", function () {
    // 高さ揃え
    if (!!$.fn.matchHeight) {
      $(".js-lineup > *").matchHeight();
    }
  }); // load function

  // Android style
  if (navigator.userAgent.indexOf("Android") > 0) {
    $("html").addClass("android");
  }
  // display:none or display:block
  $("body").find(".no-js").removeClass("no-js");
  //別ページへのアンカーリンクでリンク先にヘッダーがかぶるのを防ぐ
  jQuery(window).on("load", function () {
    var headerHeight = $("header").height();
    var url = $(location).attr("href");
    if (url.indexOf("?id=") != -1) {
      var id = url.split("?id=");
      var $target = $("#" + id[id.length - 1]);
      if ($target.length) {
        var pos = $target.offset().top - headerHeight;
        $("html, body").animate({ scrollTop: pos }, 400);
      }
    }
  });
});
